export const enum EStockFilter {
  VIEW_STOCK = 'VIEW_STOCK',
  SUPPLIER = 'SUPPLIER',
  BLOCK_STOCK = 'BLOCK_STOCK',
  CODE_DISPENSATION = 'CODE_DISPENSATION',
  QUARANTAINE_MANAGEMENT = 'QUARANTAINE_MANAGEMENT'
}
